import CardTooltip from "../card-tooltip";
import "../../../css/keyword.scss";
import { Typography } from "@mui/material";
import Services from "../../../../Layout/component/Services";

const ServicesTooltip = ({ title, color }) => {
  return (
    <CardTooltip
      placement="bottom"
      disableInteractive
      element={
        <>
          <Typography
            className="heading-small point p-2 px-4"
            sx={{
              color: color,
              fontWeight: 500,
              textTransform: "capitalize",
              fontFamily: "Work Sans",
              ":hover": {
                textDecoration: "underline",
              },
            }}
          >
            {title}
          </Typography>
        </>
      }
    >
      <Services />
    </CardTooltip>
  );
};

export default ServicesTooltip;
